import { localization } from "@/constants";
import { LanguagesEnum } from "@/enums";

export default {
  isShowLoading: false,
  isShowSnackbar: false,
  snackbarType: null,
  snackbarMessage: "",
  queryParams: {},
  weatherData: {},
  isSearchCityOpen: false,
  isErrorInGetData: false,
  localization: localization[LanguagesEnum.fa],
};
